import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=2bec4930&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=2bec4930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec4930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bec4930')) {
      api.createRecord('2bec4930', component.options)
    } else {
      api.reload('2bec4930', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=2bec4930&scoped=true&", function () {
      api.rerender('2bec4930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/Form.vue"
export default component.exports